import type { Editor } from "grapesjs";

export function removePresetBlocks(editor: Editor) {
  const bm = editor.BlockManager;

  const idsToRemove = [
    "link-block",
    "quote",
    "text-basic",
    "text-section",
  ];

  idsToRemove.forEach((id) => {
    if (bm.get(id)) bm.remove(id);
  });
}